// extracted by mini-css-extract-plugin
module.exports = {"btns":"Edit_btns__gdN3c","update":"Edit_update__3XMEC","update-dark":"Edit_update-dark__30BUt","delete":"Edit_delete__2qDCE","delete-dark":"Edit_delete-dark__KZy1s"};